function TextAppear() {
	this.build();
	// resizeCallbacks.push(this);
}

TextAppear.prototype.build = function () {
    const items = document.querySelectorAll("[data-text-appear]");

    items.forEach(elem => {
        const innerSplit = new SplitText(elem, {
            type: "lines",
            linesClass: "split-inner"
        });
        const outerSplit = new SplitText(elem, {
            type: "lines",
            linesClass: "split-outer"
        });

        const splitTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: elem,
                start: "top 100%",
                end: "bottom 0%",
            },
            onComplete: () => {
                outerSplit.revert();
                innerSplit.revert();
            }
        });

        splitTimeline.set(elem, {
            visibility: 'visible'
        });

        splitTimeline.from(innerSplit.lines, {
            duration: 1.5,
            yPercent: 150,
            ease: "power4",
            stagger: 0.15,
            autoAlpha: 0
        });
    });
};

/*TextAppear.prototype.computeSplitText = function () {
	this.splittexts = new SplitText("[data-text-appear]",
		{
			type: "lines,chars",
			charsClass: 'char',
			linesClass: 'line',
		});
};

TextAppear.prototype.resize = function () {
	this.splittexts.revert();
	this.computeSplitText();
};*/
